/**
 * Reading Mode Toggle — Artemis Therapeutics
 *
 * Article-scoped dark mode. Only affects the .article-template container
 * and the .article-progress-bar (which sits outside the article element).
 * Does not touch header, footer, or any other page.
 *
 * - localStorage persistence (key: artemis-reading-mode)
 * - Restores saved preference on article pages
 * - Smooth transitions enabled after first toggle
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'artemis-reading-mode';
  var DARK = 'dark';

  function getPreference() {
    return localStorage.getItem(STORAGE_KEY);
  }

  function applyMode(mode) {
    var article = document.querySelector('.article-template');
    var progressBar = document.querySelector('.article-progress-bar');
    if (!article) return;

    if (mode === DARK) {
      article.setAttribute('data-reading-mode', DARK);
      if (progressBar) progressBar.setAttribute('data-reading-mode', DARK);
    } else {
      article.removeAttribute('data-reading-mode');
      if (progressBar) progressBar.removeAttribute('data-reading-mode');
    }
  }

  function currentMode() {
    var article = document.querySelector('.article-template');
    return article && article.getAttribute('data-reading-mode') === DARK ? DARK : 'light';
  }

  function enableTransitions() {
    var article = document.querySelector('.article-template');
    var progressBar = document.querySelector('.article-progress-bar');
    if (article && !article.classList.contains('rm-ready')) {
      article.classList.add('rm-ready');
    }
    if (progressBar && !progressBar.classList.contains('rm-ready')) {
      progressBar.classList.add('rm-ready');
    }
  }

  function updateLabel() {
    var buttons = document.querySelectorAll('.reading-mode-toggle');
    var isDark = currentMode() === DARK;
    for (var i = 0; i < buttons.length; i++) {
      var label = buttons[i].querySelector('.reading-mode-toggle__label');
      if (label) {
        label.textContent = isDark ? 'Day mode' : 'Night mode';
      }
      buttons[i].setAttribute('aria-pressed', isDark ? 'true' : 'false');
    }
  }

  function handleToggle() {
    // Enable transitions on first toggle (not on page load — prevents flash)
    enableTransitions();

    var next = currentMode() === DARK ? 'light' : DARK;
    if (next === DARK) {
      localStorage.setItem(STORAGE_KEY, DARK);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    applyMode(next);
    updateLabel();
  }

  function init() {
    var buttons = document.querySelectorAll('.reading-mode-toggle');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', handleToggle);
    }

    // Restore saved preference instantly (no transition)
    if (getPreference() === DARK) {
      applyMode(DARK);
      updateLabel();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
